import React from 'react'
import { Link } from 'react-router-dom'
import { Trans } from '@lingui/macro'
import {
  Alert,
  AlertDescription,
  AlertIcon,
  AlertTitle,
  Box
} from '@chakra-ui/react'

import { staticLinks } from '../../../shared/linkBuilder'

export const PageWithSingleAlertAndBackToLogin: React.FC<{
  title: string
  description?: string
}> = ({ title, description }) => {
  return (
    <Box m={2}>
      <Alert
        margin={'40px auto 32px'}
        status="error"
        borderRadius="8px"
        flexWrap={['wrap', 'initial']}
      >
        <AlertIcon />
        <AlertTitle mr={2}>{title}</AlertTitle>
        <br />
        <AlertDescription mt={[3, 0]}>{description}</AlertDescription>
      </Alert>
      <Box textAlign="center">
        <Link to={staticLinks.login}>
          <Trans>back to login</Trans>
        </Link>
      </Box>
    </Box>
  )
}

export const PageWithSingleAlert: React.FC<{
  title: string
  description?: string
}> = ({ title, description }) => {
  return (
    <Box m={2}>
      <Alert
        margin={'40px auto 32px'}
        status="error"
        borderRadius="8px"
        flexWrap={['wrap', 'initial']}
      >
        <AlertIcon />
        <AlertTitle mr={2}>{title}</AlertTitle>
        <br />
        <AlertDescription mt={[3, 0]}>{description}</AlertDescription>
      </Alert>
    </Box>
  )
}
